// Copyright (c) 2025 WSO2 LLC. (https://www.wso2.com).
//
// WSO2 LLC. licenses this file to you under the Apache License,
// Version 2.0 (the "License"); you may not use this file except
// in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

import React from "react";
import { View } from "@view/index";
import { Role } from "@slices/authSlice/auth";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import { isIncludedRole } from "@utils/utils";
// Temporarily hiding the Help route until we have the content ready
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { RouteObject, NonIndexRouteObject } from "react-router-dom";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

export interface RouteObjectWithRole extends NonIndexRouteObject {
  allowRoles: string[];
  icon:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  text: string;
  children?: RouteObjectWithRole[];
  bottomNav?: boolean;
}

interface RouteDetail {
  path: string;
  allowRoles: string[];
  icon:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  text: string;
  bottomNav?: boolean;
}

export const routes: RouteObjectWithRole[] = [
  {
    path: "/",
    text: "Visit",
    icon: React.createElement(DomainAddIcon),
    element: React.createElement(View.employee),
    allowRoles: [Role.ADMIN, Role.EMPLOYEE, Role.EXTERNAL_USER],
  },
  {
    path: "/admin-panel",
    text: "Admin Panel",
    icon: React.createElement(AdminPanelSettingsOutlinedIcon),
    element: React.createElement(View.admin),
    allowRoles: [Role.ADMIN],
  },
  {
    path: "/scanner",
    text: "Scanner",
    icon: React.createElement(QrCodeScannerIcon),
    element: React.createElement(View.scanner),
    allowRoles: [Role.ADMIN],
  },
  // Temporarily hiding the Help route until we have the content ready
  // {
  //   path: "/help",
  //   text: "Help",
  //   icon: React.createElement(HelpOutlineIcon),
  //   element: React.createElement(View.help),
  //   allowRoles: [Role.ADMIN, Role.EMPLOYEE],
  //   bottomNav: true,
  // },
];
export const getActiveRoutesV2 = (
  routes: RouteObjectWithRole[] | undefined,
  roles: string[],
): RouteObjectWithRole[] => {
  if (!routes) return [];
  var routesObj: RouteObjectWithRole[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        ...routeObj,
        children: getActiveRoutesV2(routeObj.children, roles),
      });
    }
  });

  return routesObj;
};

export const getActiveRoutes = (roles: string[]): RouteObject[] => {
  var routesObj: RouteObject[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        ...routeObj,
      });
    }
  });
  return routesObj;
};

export const getActiveRouteDetails = (roles: string[]): RouteDetail[] => {
  var routesObj: RouteDetail[] = [];
  routes.forEach((routeObj) => {
    if (isIncludedRole(roles, routeObj.allowRoles)) {
      routesObj.push({
        path: routeObj.path ? routeObj.path : "",
        ...routeObj,
      });
    }
  });
  return routesObj;
};
